import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class MediaGallery extends BaseComponent {

  constructor(element) {
    super(element);

    debug && console.log('MediaGallery');

    this.GRAB(this.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen, this.onModal);
  }

  onModal = event => {
    debug && console.log('MediaGallery onModal', event);

    const element = event.vexInstance.contentEl;
    const video = element.classList.contains('media-gallery-video');

    if (video) {
      // moved to ModalTriggerComponent
      // initVideos(element);
    } else {
      let slideIndex = 0;
      if(document.querySelector('.slick-current.slick-active')) {
        slideIndex = document.querySelector('.slick-current.slick-active').getAttribute('data-slick-index');
      }
      setTimeout(() => {
        this.EMIT(this.CUSTOM_MESSAGES.CAROUSEL_EVENTS.goToSlide, {
          slide: slideIndex,
          force: true
        });
      }, 250);
    }

    // PITTI20-800 PITTI20-1413
    event.vexInstance.doNotCloseModalsOnResize = true;
  }
}
